package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val AddButtonStyle = CssStyle {
    base {
        Modifier.padding(8.px)
    }
    Breakpoint.MD {
        Modifier.padding(12.px)
    }
}

val AddButtonIconStyle = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(25.px)
    }
}

val AddButtonTextStyle = CssStyle {
    base {
        Modifier.fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}